export default "__VITE_ASSET__DcKc4Oen__"